module.exports = __webpack_public_path__ + "img/DW365-149.bb7e5fa0.jpg";